<template>
  <div class="c-profiles-list">
    <div class="c-profiles__headline1">
      <h1 class="o-typography__headline1">
        <template v-if="isEditMode">
          {{ $t('subscriber.profile.manage') }}
        </template>
        <template v-else>
          {{ $t('subscriber.profile.whoIsWatching') }}
        </template>
      </h1>
      <v-message
        v-if="showLimitError"
        :message="$t('subscriber.errors.profileLimitExceeded')"
        class="c-profiles__error-badge"
      ></v-message>
    </div>

    <div class="c-profiles-list__list">
      <ui-profile-item
        v-for="profile in profiles"
        :key="profile.id"
        :edit-mode="isEditMode"
        :profile="profile"
        class="c-profiles-list__item"
        @action="action"
      ></ui-profile-item>

      <div
        v-if="canAddProfile"
        class="c-profiles-list__item"
      >
        <div class="c-profiles-list__add-wrapper">
          <div
            class="c-profiles-list__add"
            @click="add"
          >
            +
          </div>
        </div>
        <div class="c-profiles-list__add-text o-typography__subtitle1">
          {{ $t('subscriber.profile.addNew') }}
        </div>
      </div>
    </div>

    <template v-if="!subscriber.isKidsTheme">
      <div
        v-if="isEditMode"
        class="o-button o-button--text c-profiles-list__button"
        @click="isEditMode = false"
      >
        <span class="o-typography__label o-button__label">{{ $t('common.done') }}</span>
      </div>
      <div
        v-else
        class="c-profiles-list__buttons"
      >
        <div
          class="o-button o-button--text c-profiles-list__button"
          @click="close"
        >
          <span class="o-typography__label o-button__label">
            {{ $t('common.close') }}
          </span>
        </div>
        <div
          class="o-button o-button--text c-profiles-list__button"
          @click="isEditMode = true"
        >
          <span class="o-typography__label o-button__label">
            {{ $t('subscriber.profile.manage') }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import { VMessage } from '@/index/shared/components';
  import UiProfileItem from './item.vue';
  import ProfileAction from './profile-action';

  export default {
    components: {
      UiProfileItem,
      VMessage,
    },
    props: {
      editMode: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        info: this.$services.resolve('info'),
        profilesService: this.$services.resolve('profiles'),
        subscriber: this.$services.resolve('subscriber'),
        profiles: [],
        isEditMode: true,
        showLimitError: false,
      };
    },
    computed: {
      canAddProfile() {
        return this.isEditMode && !this.subscriber.isKidsTheme;
      },
      profileLimitExceeded() {
        return this.profiles.length >= this.info.maxProfilesCount;
      },
    },
    mounted() {
      this.isEditMode = this.editMode;
      this.init();
    },
    methods: {
      init() {
        if (!this.subscriber.isLogged) {
          return;
        }

        this.profiles = this.profilesService.collection.records;
      },
      action(...rest) {
        this.$emit('action', ...rest);
      },
      add() {
        this.showLimitError = this.profileLimitExceeded;

        if (this.showLimitError) {
          return;
        }

        this.$emit('action', ProfileAction.SHOW_ADD);
      },
      close() {
        this.$emit('action', ProfileAction.CLOSE);
      },
    },
  };
</script>
